import axios from 'axios'

const fetchIpAddress = async () => {
  try {
    const response = await axios.get(process.env.REACT_APP_GET_IP_ADDRESS_ENDPOINT_URL)
    const { 'ip-address': ipAddress, country, 'country-region': countryRegion } = response.headers
    return { ipAddress, country, countryRegion }
  } catch (e) {
    throw new Error('Unable to get IP address.')
  }
}
export default fetchIpAddress
